// Flatpickr check at cart

$(document).ready(function () {
    $("body").on(
        "click",
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function () {
          if ($('#lieferzeit').val() !== '' && $('#lieferdatum').val() !== '') {
             $(this).submit();
          } else { 
            alert(
              "Bitte Lieferzeit und Datum ausfüllen."
              );
            return false;
          }
        }
    );
});


$(document).ready(function () {
    // Abholdatum nur wenn entsprechendes Produkt
    if (!$('p.delivery-details__abholung--title').hasClass('d-none')) {
        $("body").on(
            "click",
            '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
            function () {
                if ($('#abholzeit').val() !== '' && $('#abholdatum').val() !== '') {
                    $(this).submit();
                } else {
                    alert("Bitte Abholzeit und Datum ausfüllen.");
                    return false;
                }
            }
        );
    }
});

// Flatpickr

function rmydays(date) {
 return (date.getDay() === 0 || date.getDay() === 6);
}

function rmholidays(date) {
  return (
    // January = 0
    ((date.getDate() === 25 || date.getDate() === 26) && date.getMonth() === 11) //|| 
    //(date.getDate() === 1 && date.getMonth() === 0) 
  );
}

flatpickrconfig = {
  enableTime: false,
  dateFormat: 'd.m.Y',
  mode: 'range',
  //disable: [rmydays], // Wochenenden entfernen
  minDate: new Date().fp_incr(1),
  //maxDate: new Date().fp_incr(180), // 6 Monate
  locale: 'de',
  weekNumbers: true,
  allowInput: true
}

// flatpickr("input[type=datetime-local]", flatpickrconfig);

const hoehlFlatpickr = () => {
  const _ = document

  // Config
  const config = {
    startSelector: '.datepicker-start',
    endSelector: '.datepicker-end',
    enableTime: false,
    dateFormat: 'd.m.Y',
    locale: 'de',
    weekNumbers: true,
    allowInput: true
  }

  // End field
  const _endDate = _.querySelector(config.endSelector)

  // Start
  if (_.querySelector(config.startSelector) !== null) {
    startPicker = flatpickr(config.startSelector, {
      enableTime: config.enableTime,
      dateFormat: config.dateFormat,
      // mode: 'range',
      disable: [rmydays, rmholidays, "29-03-2024", "29-03-2024", "01-04-2024", "01.05.2024", "09-05-2024", "20-05-2024", "30-05-2024", "03-10-2024", "01-11-2024", "24-12-2024", "31-12-2024", "01-01-2025", "18-04-2025", "21-04-2025", "01-05-2025", "29-05-2025", "09-06-2025", "19-06-2025", "03-10-2025", "01-11-2025", "24-12-2025", "31-12-2025", "01-01-2026", "03-04-2026", "06-04-2026", "01-05-2026", "14-05-2026", "25-05-2026", "04-06-2026", "03-10-2026", "01-11-2026", "24-12-2026", "31-12-2026"], // Disable weekends and holidays
      minDate: new Date().fp_incr(1),
      //maxDate: new Date().fp_incr(14), // 14 Tage
      locale: config.locale,
      weekNumbers: config.weekNumbers,
      onChange: function(selectedDates, dateStr, instance) {
        if (selectedDates.length > 0) {
          endPicker.set('minDate', selectedDates[0].fp_incr(1)) // Selected date +1 day
          _endDate.removeAttribute('disabled')
        } else {
          _endDate.setAttribute('disabled', 'disabled')
          _endDate.value = ''
        }
      }
    })
  }

  // End
  if (_.querySelector(config.endSelector) !== null) {
    endPicker = flatpickr(config.endSelector, {
      enableTime: config.enableTime,
      dateFormat: config.dateFormat,
      disable: [rmydays, rmholidays, "29-03-2024", "29-03-2024", "01-04-2024", "01.05.2024", "09-05-2024", "20-05-2024", "30-05-2024", "03-10-2024", "01-11-2024", "24-12-2024", "31-12-2024", "01-01-2025", "18-04-2025", "21-04-2025", "01-05-2025", "29-05-2025", "09-06-2025", "19-06-2025", "03-10-2025", "01-11-2025", "24-12-2025", "31-12-2025", "01-01-2026", "03-04-2026", "06-04-2026", "01-05-2026", "14-05-2026", "25-05-2026", "04-06-2026", "03-10-2026", "01-11-2026", "24-12-2026", "31-12-2026"], // Disable weekends and holidays
      locale: config.locale,
      weekNumbers: config.weekNumbers
    })
  }
}

hoehlFlatpickr()